import { render, staticRenderFns } from "./AsignacionEquipoSubsedeDialogComponent.vue?vue&type=template&id=36abb49f"
import script from "./AsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"
export * from "./AsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports